    import React, { useState, useEffect } from 'react';

    // Helper component for Lucide Icons
    const Icon = ({ name, className }) => (
        <i data-lucide={name} className={className}></i>
    );


    // --- Reusable Components ---

    // ADD THIS UPDATED BLOCK
    const Header = ({ currentPage, setCurrentPage }) => {
        const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
        // NOTE: The 'openDropdown' state has been removed, as the hover is now handled by CSS.

        const navLinks = [
            { name: 'Home', page: 'home' },
            { name: "I'm New", page: 'new-here' },
            { 
                name: 'About Us', 
                page: 'about',
                subMenu: [
                    { name: 'Our Mission & Vision', page: 'about', section: 'about-main' },
                    { name: 'Meet Our Leadership', page: 'about', section: 'leaders' },
                    { name: 'Community Moments', page: 'community-moments' }
                ]
            },
            { name: 'Services', page: 'services' },
            { name: 'Events', page: 'events' },
            { name: 'Giving', page: 'giving' },
        ];

        const handleNavClick = (e, page, section = null) => {
            e.preventDefault();
            
            // Close mobile menu
            setMobileMenuOpen(false);
            
            if (currentPage === page && section) {
                document.getElementById(section)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else {
                setCurrentPage(page);
                if (section) {
                    setTimeout(() => {
                        document.getElementById(section)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }, 100);
                }
            }
        };

        const NavLink = ({ link }) => {
            const isActive = currentPage === link.page;
            const hasSubMenu = !!link.subMenu;

            if (hasSubMenu) {
                return (
                    // By adding 'group', we can now use 'group-hover' on child elements.
                    <div className="relative group">
                        <button
                            className={`transition-colors duration-300 flex items-center py-4 ${isActive ? 'text-orange-400' : 'text-white hover:text-orange-400'}`}
                        >
                            {link.name}
                            <Icon name="chevron-down" className="w-4 h-4 ml-1" />
                        </button>
                        {/* This dropdown is now controlled by CSS. It's always in the DOM but starts
                        invisible and becomes visible on 'group-hover'.
                        */}
                        <div className="absolute top-full left-1/2 -translate-x-1/2 w-56 bg-white rounded-md shadow-lg py-2 z-50
                                        opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300
                                        transform scale-95 group-hover:scale-100">
                            {link.subMenu.map(subLink => (
                                <a
                                    key={subLink.name}
                                    href={`#${subLink.page}`}
                                    onClick={(e) => handleNavClick(e, subLink.page, subLink.section)}
                                    className="block px-4 py-2 text-stone-700 hover:bg-orange-100"
                                >
                                    {subLink.name}
                                </a>
                            ))}
                        </div>
                    </div>
                );
            }

            return (
                <a
                    href={`#${link.page}`}
                    onClick={(e) => handleNavClick(e, link.page)}
                    className={`transition-colors duration-300 py-4 ${isActive ? 'text-orange-400' : 'text-white hover:text-orange-400'}`}
                >
                    {link.name}
                </a>
            );
        };

        return (
            <header className="bg-[#4a2318]/90 backdrop-blur-sm fixed top-0 left-0 right-0 z-50 shadow-md">
                <div className="container mx-auto px-6 py-0">
                    <nav className="flex justify-between items-center">
                        <a href="#home" onClick={(e) => handleNavClick(e, 'home')} className="flex items-center">
                            <img src="/images/hci-logo.jpg" alt="Harvest Chapel International Logo" className="h-12 md:h-14" />
                        </a>
                        <div className="hidden md:flex items-center space-x-8">
                            {navLinks.map(link => <NavLink key={link.name} link={link} />)}
                        </div>
                        <button onClick={() => setMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden text-white">
                            <Icon name={isMobileMenuOpen ? "x" : "menu"} className="w-6 h-6" />
                        </button>
                    </nav>
                </div>
                {/* Mobile Menu */}
                {isMobileMenuOpen && (
                    <div className="md:hidden bg-[#4a2318]">
                        {navLinks.map(link => (
                            <div key={link.page}>
                                {link.subMenu ? (
                                    <>
                                        <span className="block text-center text-orange-200 font-bold py-3 px-4">{link.name}</span>
                                        {link.subMenu.map(subLink => (
                                            <a
                                                key={subLink.name}
                                                href={`#${subLink.page}`}
                                                onClick={(e) => handleNavClick(e, subLink.page, subLink.section)}
                                                className="block text-center text-white py-3 px-8 hover:bg-[#5d3a2f] bg-[#542d23]"
                                            >
                                                {subLink.name}
                                            </a>
                                        ))}
                                    </>
                                ) : (
                                    <a
                                        href={`#${link.page}`}
                                        onClick={(e) => handleNavClick(e, link.page)}
                                        className="block text-center text-white py-3 px-4 hover:bg-[#5d3a2f]"
                                    >
                                        {link.name}
                                    </a>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </header>
        );
    };

    const Footer = () => (
    <footer className="bg-[#2c120c] text-slate-400 py-12">
        <div className="container mx-auto px-6 text-center">
             <div className="mb-6">
                  <h3 className="text-xl font-bold text-white font-playfair mb-2">HCI Agape Temple</h3>
                  <p>8486 Bowden St, Douglasville, GA 30134</p>
                  <p><a href="tel:+14049446274" className="hover:text-orange-400">(404) 944-6274</a></p>
             </div>
            <div className="flex justify-center space-x-6 mb-6">
                <a href="https://www.facebook.com/harvestatlanta?rdid=HzThN0EDSLLzC4WQ&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F18tjNsmtyE%2F#" target="_blank" rel="noopener noreferrer" className="hover:text-orange-400 transition-colors"><Icon name="facebook" className="w-6 h-6" /></a>
                <a href="https://www.instagram.com/_harvestatlanta" target="_blank" rel="noopener noreferrer" className="hover:text-orange-400 transition-colors"><Icon name="instagram" className="w-6 h-6" /></a>
                <a href="https://www.youtube.com/@HarvestchapelatlantaOrg0/streams" target="_blank" rel="noopener noreferrer" className="hover:text-orange-400 transition-colors"><Icon name="youtube" className="w-6 h-6" /></a>
            </div>
            <p>© {new Date().getFullYear()} Harvest Chapel International - Agape Temple. All Rights Reserved.</p>
        </div>
    </footer>
);

    const SectionTitle = ({ children, lightText=false }) => <h2 className={`text-3xl md:text-4xl font-playfair font-bold ${lightText ? 'text-white' : 'text-stone-800'} mb-4 text-center`}>{children}</h2>;
    const SectionSubtitle = ({ children, lightText=false }) => <p className={`text-lg ${lightText ? 'text-slate-300' : 'text-stone-600'} mb-12 text-center max-w-3xl mx-auto`}>{children}</p>;


    // --- Page Components ---

    const HomePage = ({ setCurrentPage }) => {
        const ministries = [
            { name: 'Choir', img: 'https://placehold.co/400x500/a16207/FFFFFF?text=Choir' },
            { name: 'Youth Ministry', img: '/images/youth.jpeg' },
            { name: 'Kiddie Haven', img: '/images/kiddie-haven.webp' },
            { name: 'Daughters of Zion', img: '/images/doz.webp' },
            { name: 'Men of Vision', img: '/images/mov.webp' },
            { name: 'Couples Fellowship', img: 'https://placehold.co/400x500/92400e/FFFFFF?text=Couples' },
        ];

        return (
            <>
                <section className="hero-bg flex items-center justify-center text-white py-32 md:py-40">
                    <div className="text-center px-4">
                        <div className="bg-black/40 backdrop-blur-sm p-8 rounded-xl max-w-4xl">
                            <h1 className="text-4xl md:text-6xl lg:text-7xl font-playfair font-extrabold leading-tight mb-4 drop-shadow-lg">
                                Faith, Family, and Excellence
                            </h1>
                            <p className="text-lg md:text-2xl mb-10 max-w-3xl mx-auto font-light drop-shadow-md">
                                A place to experience God's love, grow in faith, and find community.
                            </p>
                            
                            <a href="#new-here" onClick={(e) => { e.preventDefault(); setCurrentPage('new-here'); }} className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-8 rounded-full text-lg transition-transform duration-300 transform hover:scale-105 cursor-pointer">
                                Plan Your Visit
                            </a>
                        </div>
                    </div>
                </section>

                <section id="welcome-pastor" className="py-20 md:py-28 bg-orange-50/50">
                    <div className="container mx-auto px-6">
                        <div className="bg-white rounded-lg shadow-xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8 md:gap-12 max-w-5xl mx-auto">
                            <div className="md:w-1/3 text-center flex-shrink-0">
                                <img 
                                    src="/images/rev-asareb-5.webp" 
                                    alt="Rev. Osafo Asare-Bediako" 
                                    className="w-48 h-48 md:w-60 md:h-60 rounded-full mx-auto shadow-lg object-cover border-4 border-white" 
                                />
                            </div>
                            <div className="md:w-2/3">
                                <h2 className="text-3xl md:text-4xl font-playfair font-bold text-stone-800 mb-4">Harvest Is Home!</h2>
                                <div className="text-stone-700 space-y-4 text-lg">
                                    <p>You are welcome to Harvest Chapel International - Atlanta branch. My name is <span className="font-bold text-stone-900">Rev. Osafo Asare-Bediako</span>, the resident pastor of Harvest Atlanta branch. It is always an honour to welcome you into God's presence.</p>
                                    <p>Our services are both in person and online. We're excited for you to join us and can't wait to welcome you.</p>
                                </div>
                                
                                <div className="mt-8">
                                    <img 
                                        src="/images/theme.webp" 
                                        alt="2025 Our Year of Fellowship" 
                                        className="w-full mx-auto rounded-lg shadow-md"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* --- ADDED: Community Highlights Section --- */}
                <section id="community-highlights" className="py-20 md:py-28 bg-white">
                    <div className="container mx-auto px-6">
                        <SectionTitle>Community in Action</SectionTitle>
                        <SectionSubtitle>
                            Experience the joy and fellowship that define our church family. These are just a few of our favorite moments together.
                        </SectionSubtitle>
                        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
                            <div className="group relative rounded-lg overflow-hidden shadow-lg aspect-w-1 aspect-h-1">
                                <img src="/images/camp.jpeg" alt="Youth Camp" className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500" />
                                <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                                    <span className="text-white text-lg font-bold">Youth Camp</span>
                                </div>
                            </div>
                            <div className="group relative rounded-lg overflow-hidden shadow-lg aspect-w-1 aspect-h-1">
                                <img src="/images/beach.JPG" alt="Church Beach Outing" className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500" />
                                <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                                    <span className="text-white text-lg font-bold">Beach Outing</span>
                                </div>
                            </div>
                            <div className="group relative rounded-lg overflow-hidden shadow-lg aspect-w-1 aspect-h-1">
                                <img src="/images/worship.jpeg" alt="Worship Night" className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500" />
                                <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                                    <span className="text-white text-lg font-bold">Worship Night</span>
                                </div>
                            </div>
                            <div className="group relative rounded-lg overflow-hidden shadow-lg aspect-w-1 aspect-h-1">
                                <img src="/images/volunteering.webp" alt="Community Service" className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500" />
                                <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                                    <span className="text-white text-lg font-bold">Community Service</span>
                                </div>
                            </div>
                        </div>
                        <div className="text-center">
                            <a href="#community-moments" onClick={(e) => { e.preventDefault(); setCurrentPage('community-moments'); }} className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-8 rounded-full text-lg transition-transform duration-300 transform hover:scale-105 cursor-pointer">
                                See More Community Moments
                            </a>
                        </div>
                    </div>
                </section>

                <section id="ministries" className="py-20 md:py-28 bg-orange-50/50">
                    <div className="container mx-auto px-6">
                        <SectionTitle>A Place For You and Your Family</SectionTitle>
                        <SectionSubtitle>
                            No matter your age or stage of life, there's a vibrant community here for you to connect with, grow, and serve.
                        </SectionSubtitle>
                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-6">
                            {ministries.map((ministry) => (
                                <div key={ministry.name} className="group relative rounded-lg overflow-hidden shadow-lg cursor-pointer">
                                    <img src={ministry.img} alt={ministry.name} className="w-full h-64 object-cover transform group-hover:scale-110 transition-transform duration-500 ease-in-out" />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                                    <h3 className="absolute bottom-0 left-0 p-4 text-white font-bold text-xl font-playfair drop-shadow-md">{ministry.name}</h3>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </>
        );
    };

    const AboutPage = () => {
        const leaders = [
            { name: 'Rev. Osafo Asare-Bediako', title: 'Resident Pastor', img: '/images/rev-asareb-1.jpeg' },
            { name: 'Ps. Love Asare-Bediako', title: 'Pastor & Daughters of Zion Leader', img: '/images/pastor-love.jpeg' },
            { name: 'Sis. Nikki Adenuga', title: 'Treasurer', img: 'https://placehold.co/400x400/d4a373/4a2318?text=Sis.+Nikki' },
            { name: 'Sis. Jenny Orgle', title: 'Secretary', img: '/images/sis-jenny.jpeg' },
            { name: 'Bro. Charles Mensah-Belley', title: 'Prayer Coordinator', img: '/images/bro-charles.jpeg' },
            { name: 'Sis. Amy Okruw', title: 'Bible Study Coordinator', img: '/images/sis-amy.jpeg' },
            { name: 'Bro. Eric Tutu', title: 'Men of Vision Leader', img: '/images/bro-eric.jpeg' },
            { name: 'Bro. Ernest Mills', title: 'Youth Leader', img: '/images/bro-ernest.jpeg' },
        ];
        
        return (
            <>
                {/* Section 1: Mission & Vision with ID */}
                <section id="about-main" className="py-20 md:py-28 bg-white">
                    <div className="container mx-auto px-6">
                        <SectionTitle>About Harvest Chapel</SectionTitle>
                        <SectionSubtitle>
                            We are the Atlanta branch of Harvest Chapel International, a ministry dedicated to raising leaders and transforming communities through the power of the Gospel.
                        </SectionSubtitle>
                        <div className="flex flex-col md:flex-row items-center gap-12">
                            <div className="md:w-1/2">
                                <img src="/images/community.jpeg" alt="Church community" className="rounded-lg shadow-xl w-full h-auto" />
                            </div>
                            <div className="md:w-1/2">
                                <h3 className="text-2xl font-bold text-stone-800 mb-4 font-playfair">Our Mission</h3>
                                <p className="mb-4 text-stone-700">To win souls, make disciples, and plant churches worldwide. We believe in the power of God's Word to change lives and are committed to creating an atmosphere of vibrant worship, deep fellowship, and impactful outreach.</p>
                                <h3 className="text-2xl font-bold text-stone-800 mb-4 font-playfair">Our Vision</h3>
                                <p className="mb-6 text-stone-700">To be a church where people from all walks of life can encounter God, discover their purpose, and be equipped to make a difference in the world. Agape Temple is a family, and there's a place for you here.</p>
                                <a href="https://www.harvestinternationalministries.org/" target="_blank" rel="noopener noreferrer" className="text-orange-600 hover:text-orange-700 font-semibold transition-colors">
                                    Learn About Our Global Ministry →
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
                
                {/* Section 2: Leadership with ID */}
                <section id="leaders" className="py-20 md:py-28 bg-orange-50/50">
                    <div className="container mx-auto px-6">
                        <SectionTitle>Meet Our Leadership</SectionTitle>
                        <SectionSubtitle>
                            Meet the team of dedicated leaders who serve our church family with passion and commitment.
                        </SectionSubtitle>
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 justify-items-center">
                            {leaders.map((leader, index) => (
                                <div key={index} className="bg-white rounded-lg shadow-lg text-center p-6 w-full max-w-xs transform hover:-translate-y-2 transition-transform duration-300">
                                    <img src={leader.img} alt={leader.name} className="w-32 h-32 rounded-full mx-auto mb-4 shadow-md object-cover object-center" />
                                    <h3 className="text-xl font-bold text-stone-800 font-playfair">{leader.name}</h3>
                                    <p className="text-orange-600 font-semibold mb-3">{leader.title}</p>
                                    <p className="text-stone-600 text-sm">
                                        This is a placeholder blurb. Replace this with a short, engaging biography about the leader, their ministry, and their passion for serving God's people.
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </>
        );
    };

    const NewHerePage = () => (
        <section id="new-here" className="py-20 md:py-28 bg-white">
            <div className="container mx-auto px-6">
                <SectionTitle>Welcome, We're Glad You're Here</SectionTitle>
                <SectionSubtitle>
                    Visiting a new church can be intimidating. We want to make your first experience at Agape Temple a great one!
                </SectionSubtitle>

                <div className="max-w-4xl mx-auto space-y-16">
                    {/* What to Expect Section */}
                    <div>
                        <h3 className="text-2xl font-bold text-stone-800 mb-4 font-playfair text-center">What to Expect</h3>
                        <div className="grid md:grid-cols-3 gap-8 text-center">
                            <div className="bg-orange-50/50 p-6 rounded-lg">
                                <Icon name="users" className="w-12 h-12 text-orange-600 mx-auto mb-4" />
                                <h4 className="font-bold text-lg mb-2">A Friendly Atmosphere</h4>
                                <p>From the moment you walk in, you'll be welcomed into a friendly, casual environment by people who are excited to see you.</p>
                            </div>
                            <div className="bg-orange-50/50 p-6 rounded-lg">
                                <Icon name="music" className="w-12 h-12 text-orange-600 mx-auto mb-4" />
                                <h4 className="font-bold text-lg mb-2">Passionate Worship</h4>
                                <p>Our services feature vibrant, contemporary worship music and an opportunity to encounter God's presence.</p>
                            </div>
                            <div className="bg-orange-50/50 p-6 rounded-lg">
                                <Icon name="book-open" className="w-12 h-12 text-orange-600 mx-auto mb-4" />
                                <h4 className="font-bold text-lg mb-2">Relevant Teaching</h4>
                                <p>We believe the Bible is God's Word for us today. You'll hear a practical, engaging message to help you grow in your faith.</p>
                            </div>
                        </div>
                    </div>

                    {/* For Your Kids Section */}
                    <div className="flex flex-col md:flex-row items-center gap-12">
                        <div className="md:w-1/2">
                            <img src="/images/kiddie-haven.webp" alt="Children's Ministry" className="rounded-lg shadow-xl w-full h-auto" />
                        </div>
                        <div className="md:w-1/2">
                            <h3 className="text-2xl font-bold text-stone-800 mb-4 font-playfair">For Your Kids</h3>
                            <p className="mb-4 text-stone-700">We believe church should be an exciting and memorable experience for kids. In Kiddie Haven, we create a fun, safe, and nurturing environment where your children can grow in their faith and in confidence. They'll enjoy upbeat songs, participate in friendly competition with Bible jeopardy, and hide God's Word in their hearts by learning memory verses. To take their growth even further, children have the opportunity to build their public speaking and creative skills by rehearsing for and performing in stage plays, recitals, and choreographies in the main church. Our goal is for your kids to leave with a smile, excited to come back next week!</p>
                        </div>
                    </div>

                    {/* Service Times & Location Section */}
                    <div>
                        <h3 className="text-2xl font-bold text-stone-800 mb-6 font-playfair text-center">Service Times & Location</h3>
                        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 bg-stone-100 p-8 rounded-lg">
                            <div className="lg:w-1/2">
                                <div className="space-y-6">
                                    <div className="flex items-start">
                                        <div className="bg-orange-100 text-orange-600 p-3 rounded-full mr-4 shrink-0">
                                            <Icon name="map-pin" className="w-6 h-6" />
                                        </div>
                                        <div>
                                            <h4 className="text-xl font-bold text-stone-800 font-playfair">Our Address</h4>
                                            <p className="text-stone-600">8486 Bowden St<br/>Douglasville, GA 30134</p>
                                        </div>
                                    </div>
                                    <div className="flex items-start">
                                        <div className="bg-orange-100 text-orange-600 p-3 rounded-full mr-4 shrink-0">
                                            <Icon name="clock" className="w-6 h-6" />
                                        </div>
                                        <div>
                                            <h4 className="text-xl font-bold text-stone-800 font-playfair">Service Times</h4>
                                            <p className="text-stone-600">Sundays: 10:00 AM</p>
                                            <p className="text-stone-600">Mondays (Online): 8:00 PM</p>
                                            <p className="text-stone-600">Fridays (Online): 7:00 PM</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="lg:w-1/2 h-64 lg:h-auto rounded-lg shadow-md overflow-hidden">
                                <iframe 
                                    className="w-full h-full"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3319.434863378521!2d-84.72146198479368!3d33.69752978070388!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f53a473a241289%3A0x7052994436531818!2s8486%20Bowden%20St%2C%20Douglasville%2C%20GA%2030134!5e0!3m2!1sen!2sus!4v1662586745123!5m2!1sen!2sus" 
                                    allowFullScreen="" 
                                    loading="lazy" 
                                    referrerPolicy="no-referrer-when-downgrade">
                                </iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );

    const ServicesPage = () => {
        // --- MONTHLY THEMES LOGIC ---
        const themes = [
            { month: 'JANUARY', title: 'STARTING WITH GOD', scripture: 'Genesis 1:1, Matthew 6:33' },
            { month: 'FEBRUARY', title: 'ORDER IN OUR LOVE', scripture: 'John 15:9' },
            { month: 'MARCH', title: 'ORDER IN OUR WORSHIP', scripture: 'Psalm 100:4' },
            { month: 'APRIL', title: 'ORDER IN OUR PRAYER', scripture: 'Luke 11:1' },
            { month: 'MAY', title: 'ORDER IN OUR CONVERSATION', scripture: 'Colossians 4:6' },
            { month: 'JUNE', title: 'ORDER IN OUR GIVING', scripture: 'Matthew 6:24' },
            { month: 'JULY', title: 'ORDER IN OUR RELATIONSHIPS', scripture: 'Ephesians 4:15' },
            { month: 'AUGUST', title: 'ORDER IN OUR SERVICE', scripture: 'Mark 10:45' },
            { month: 'SEPTEMBER', title: 'ORDER IN WINNING SOULS', scripture: 'Colossians 1:28' },
            { month: 'OCTOBER', title: 'ORDER IN SHOWING HONOUR', scripture: '1 Thessalonians 5:12' },
            { month: 'NOVEMBER', title: 'ORDER IN OUR CALLINGS', scripture: 'Romans 12:6-8' },
            { month: 'DECEMBER', title: 'ORDER IN OBEDIENCE TO THE HOLY SPIRIT', scripture: '1 Corinthians 14:14' },
        ];

        const date = new Date();
        const currentMonthIndex = date.getMonth(); 
        const currentTheme = themes[currentMonthIndex];
        const nextTheme = themes[currentMonthIndex + 1];
        const monthAfterNextTheme = themes[currentMonthIndex + 2];


        // --- LIVE SCHEDULE LOGIC ---
        // We use a state to track the current time so the buttons update automatically
        // if the user leaves the page open.
        const [now, setNow] = useState(new Date());

        useEffect(() => {
            const timer = setInterval(() => setNow(new Date()), 60000); // Update every minute
            return () => clearInterval(timer);
        }, []);

        // Helper to check if a specific time slot is currently active
        // dayIndex: 0=Sun, 1=Mon, ..., 5=Fri
        // startHour: 24-hour format (e.g., 10 for 10am, 20 for 8pm)
        // endHour: 24-hour format
        const isLive = (dayIndex, startHour, endHour) => {
            const currentDay = now.getDay();
            const currentHour = now.getHours();
            
            return currentDay === dayIndex && currentHour >= startHour && currentHour < endHour;
        };

        // Check status for each specific service
        const isSundayLive = isLive(0, 10, 12); // Sunday 10am - 12pm
        const isMondayLive = isLive(1, 20, 21); // Monday 8pm - 9pm
        const isFridayLive = isLive(5, 19, 20); // Friday 7pm - 8pm

        // Helper component for the "Watch" button
        // Swaps styles based on 'active' status
        const LiveButton = ({ active, href, label, icon }) => {
            if (active) {
                return (
                    <a href={href} target="_blank" rel="noopener noreferrer" 
                       className="w-full bg-red-600 hover:bg-red-700 text-white font-bold py-3 px-6 rounded shadow-lg transition-all duration-300 flex items-center justify-center animate-pulse">
                        <span className="relative flex h-3 w-3 mr-2">
                          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
                          <span className="relative inline-flex rounded-full h-3 w-3 bg-white"></span>
                        </span>
                        JOIN LIVE NOW
                    </a>
                );
            }
            return (
                <a href={href} target="_blank" rel="noopener noreferrer" 
                   className="text-orange-700 font-bold hover:text-orange-800 transition-colors flex items-center justify-center text-center">
                    <Icon name={icon} className="w-5 h-5 mr-2" />
                    <span>{label}</span>
                </a>
            );
        };

        return (
            <section id="services" className="py-20 md:py-28 bg-orange-50/50">
                <div className="container mx-auto px-6">
                    
                    {/* --- Theme of the Month Section --- */}
                    <div className="mb-20">
                        <SectionTitle>Theme of the Month</SectionTitle>
                        <SectionSubtitle>
                            Every month, we unite around a specific spiritual focus to guide our walk with God.
                        </SectionSubtitle>

                        {/* Current Month Card */}
                        <div className="bg-white rounded-xl shadow-xl overflow-hidden max-w-4xl mx-auto border-l-8 border-orange-500 mb-12">
                            <div className="p-8 md:p-12 text-center">
                                <span className="inline-block bg-orange-100 text-orange-800 text-xs font-bold tracking-widest px-3 py-1 rounded-full mb-4">
                                    THIS MONTH: {currentTheme?.month}
                                </span>
                                <h3 className="text-3xl md:text-5xl font-playfair font-bold text-stone-800 mb-6">
                                    {currentTheme?.title}
                                </h3>
                                <div className="inline-block border-t border-b border-orange-200 py-3 px-8">
                                    <p className="text-xl text-stone-600 font-serif italic">
                                        "{currentTheme?.scripture}"
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Upcoming Months Section */}
                        {nextTheme && (
                            <div className="max-w-4xl mx-auto">
                                <h4 className="text-stone-500 font-bold uppercase tracking-wider text-sm mb-4 text-center md:text-left">Coming Up Next</h4>
                                <div className="grid md:grid-cols-2 gap-6">
                                    {/* Next Month */}
                                    <div className="bg-white p-6 rounded-lg shadow border border-orange-100 flex flex-col md:flex-row items-center md:items-start text-center md:text-left">
                                        <div className="bg-stone-800 text-white rounded-lg p-3 min-w-[80px] text-center mb-4 md:mb-0 md:mr-6">
                                            <span className="block text-xs font-bold uppercase opacity-75">Month</span>
                                            <span className="block font-playfair font-bold">{nextTheme.month.substring(0, 3)}</span>
                                        </div>
                                        <div>
                                            <h5 className="font-bold text-lg text-stone-800">{nextTheme.title}</h5>
                                            <p className="text-orange-600 text-sm">{nextTheme.scripture}</p>
                                        </div>
                                    </div>
                                    
                                    {/* Month After Next */}
                                    {monthAfterNextTheme && (
                                        <div className="bg-white p-6 rounded-lg shadow border border-orange-100 flex flex-col md:flex-row items-center md:items-start text-center md:text-left">
                                            <div className="bg-stone-200 text-stone-600 rounded-lg p-3 min-w-[80px] text-center mb-4 md:mb-0 md:mr-6">
                                                <span className="block text-xs font-bold uppercase opacity-75">Month</span>
                                                <span className="block font-playfair font-bold">{monthAfterNextTheme.month.substring(0, 3)}</span>
                                            </div>
                                            <div>
                                                <h5 className="font-bold text-lg text-stone-800">{monthAfterNextTheme.title}</h5>
                                                <p className="text-orange-600 text-sm">{monthAfterNextTheme.scripture}</p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                    
                    <hr className="border-stone-300 my-16 max-w-2xl mx-auto" />

                    {/* --- Weekly Services Section with LIVE Logic --- */}
                    <SectionTitle>Our Weekly Services</SectionTitle>
                    <SectionSubtitle>
                        Join us for a time of worship, fellowship, and a powerful message from the Word.
                    </SectionSubtitle>
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                        
                        {/* Sunday Service Card */}
                        <div className={`bg-white rounded-lg shadow-lg overflow-hidden transform hover:-translate-y-2 transition-transform duration-300 flex flex-col justify-between ${isSundayLive ? 'ring-4 ring-red-500' : ''}`}>
                            <div className="p-6">
                                <div className="flex justify-between items-start">
                                    <p className="text-orange-600 font-semibold text-sm">SUNDAYS</p>
                                    {isSundayLive && <span className="bg-red-600 text-white text-xs font-bold px-2 py-1 rounded animate-pulse">LIVE NOW</span>}
                                </div>
                                <h3 className="text-xl font-bold text-stone-800 mt-2 mb-3 font-playfair">Worship Service</h3>
                                <p className="text-stone-600 mb-4">Join us for a powerful time of worship, prayer, and an inspiring message from the Word.</p>
                                <div className="flex items-center text-sm text-stone-500">
                                    <Icon name="clock" className="w-4 h-4 mr-2" />
                                    <span>10:00 AM - 12:00 PM</span>
                                </div>
                            </div>
                            <div className={`p-4 border-t ${isSundayLive ? 'bg-red-50 border-red-100' : 'bg-orange-50/50 border-orange-100'}`}>
                                <LiveButton 
                                    active={isSundayLive} 
                                    href="https://www.youtube.com/@HarvestchapelatlantaOrg0/streams" 
                                    label="Watch Live on YouTube"
                                    icon="youtube"
                                />
                            </div>
                        </div>

                        {/* Monday Prayer Meeting Card */}
                        <div className={`bg-white rounded-lg shadow-lg overflow-hidden transform hover:-translate-y-2 transition-transform duration-300 flex flex-col justify-between ${isMondayLive ? 'ring-4 ring-red-500' : ''}`}>
                            <div className="p-6">
                                <div className="flex justify-between items-start">
                                    <p className="text-orange-600 font-semibold text-sm">MONDAYS</p>
                                    {isMondayLive && <span className="bg-red-600 text-white text-xs font-bold px-2 py-1 rounded animate-pulse">LIVE NOW</span>}
                                </div>
                                <h3 className="text-xl font-bold text-stone-800 mt-2 mb-3 font-playfair">Prayer Meeting</h3>
                                <p className="text-stone-600 mb-4">Join us to seek God's face, intercede for our community, and experience the power of corporate prayer.</p>
                                <div className="flex items-center text-sm text-stone-500">
                                    <Icon name="clock" className="w-4 h-4 mr-2" />
                                    <span>8:00 PM - 9:00 PM (Online)</span>
                                </div>
                            </div>
                            <div className={`p-4 border-t ${isMondayLive ? 'bg-red-50 border-red-100' : 'bg-orange-50/50 border-orange-100'}`}>
                                <LiveButton 
                                    active={isMondayLive} 
                                    href="https://us02web.zoom.us/j/4044047700?pwd=OVBTbFFHRk9OTWlBazE1b0p5RFZpQT09" 
                                    label="Join Online via Zoom"
                                    icon="video"
                                />
                            </div>
                        </div>

                        {/* Friday Bible Study Card */}
                        <div className={`bg-white rounded-lg shadow-lg overflow-hidden transform hover:-translate-y-2 transition-transform duration-300 flex flex-col justify-between ${isFridayLive ? 'ring-4 ring-red-500' : ''}`}>
                            <div className="p-6">
                                <div className="flex justify-between items-start">
                                    <p className="text-orange-600 font-semibold text-sm">FRIDAYS</p>
                                    {isFridayLive && <span className="bg-red-600 text-white text-xs font-bold px-2 py-1 rounded animate-pulse">LIVE NOW</span>}
                                </div>
                                <h3 className="text-xl font-bold text-stone-800 mt-2 mb-3 font-playfair">Bible Study</h3>
                                <p className="text-stone-600 mb-4">Dive deeper into the scriptures with us. A great place to ask questions and grow in your understanding.</p>
                                <div className="flex items-center text-sm text-stone-500">
                                    <Icon name="book-open" className="w-4 h-4 mr-2" />
                                    <span>7:00 PM - 8:00 PM (Online)</span>
                                </div>
                            </div>
                            <div className={`p-4 border-t ${isFridayLive ? 'bg-red-50 border-red-100' : 'bg-orange-50/50 border-orange-100'}`}>
                                <LiveButton 
                                    active={isFridayLive} 
                                    href="https://us02web.zoom.us/j/4044047700?pwd=OVBTbFFHRk9OTWlBazE1b0p5RFZpQT09" 
                                    label="Join Online via Zoom"
                                    icon="video"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        );
    };

    const EventsPage = () => {
            const events = [
            {
                title: "21 Days of Fasting & Prayer",
                date: "January 12th - February 1st, 2026",
                description: "A time of renewal, alignment, and power. Join us as we seek the Lord during our 21 Days of Fasting and Prayer. Let’s set the spiritual foundation for a victorious Year of Divine Order together.",
                img: "/images/fasting.webp"
            }
        ];

        return (
            <section id="events" className="py-20 md:py-28 bg-white">
                <div className="container mx-auto px-6">
                    <SectionTitle>Upcoming Events</SectionTitle>
                    <SectionSubtitle>
                        Mark your calendars for these special events designed for fellowship and outreach.
                    </SectionSubtitle>
                    <div className="max-w-4xl mx-auto space-y-12">
                        {events.map((event, index) => (
                            <div key={index} className="bg-orange-50/50 rounded-lg shadow-lg overflow-hidden flex flex-col md:flex-row items-center">
                                <div className="md:w-1/3">
                                    <img src={event.img} alt={event.title} className="w-full h-64 md:h-full object-cover" />
                                </div>
                                <div className="md:w-2/3 p-8">
                                    <h3 className="text-2xl font-bold text-stone-800 font-playfair mb-2">{event.title}</h3>
                                    <p className="text-orange-600 font-semibold mb-4">{event.date}</p>
                                    <p className="text-stone-700">{event.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        );
    };


    const GivingPage = () => {
        // State to manage the copy-to-clipboard feedback
        const [copiedItem, setCopiedItem] = useState(null); // Can be 'zelle' or 'venmo'
        const zellePhone = '+14049446274';
        const zellePhoneDisplay = '(404) 944-6274';

        // Function to handle copying text for either Zelle or Venmo
        const handleCopy = (phone, item) => {
            navigator.clipboard.writeText(phone).then(() => {
                setCopiedItem(item); // Set which item was copied
                // Reset the message after 2 seconds
                setTimeout(() => {
                    setCopiedItem(null);
                }, 2000);
            }).catch(err => {
                console.error('Failed to copy text: ', err);
            });
        };

        return (
            <section id="giving" className="py-20 md:py-28 bg-orange-50/50">
                <div className="container mx-auto px-6 text-center">
                    <SectionTitle>Offerings, Tithes & Donations</SectionTitle>
                    <SectionSubtitle>
                        Your generosity enables us to fulfill our mission of spreading the Gospel and serving our community. Thank you for your faithful support.
                    </SectionSubtitle>

                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto mt-16">
                        {/* --- Zelle Card (Further UI improvements) --- */}
                        <div className="bg-white rounded-lg shadow-lg p-6 md:p-8 text-center flex flex-col items-center transform hover:-translate-y-2 transition-transform duration-300">
                            <div className="bg-orange-100 text-orange-600 p-4 rounded-full mb-4">
                                <Icon name="landmark" className="w-8 h-8" />
                            </div>
                            <h3 className="text-2xl font-bold font-playfair text-stone-800 mb-2">Give with Zelle</h3>
                            <p className="text-stone-600 mb-6 grow">Give through your banking app using Zelle. It's fast, safe, and has no fees.</p>
                            
                            {/* Streamlined Recipient Info Box */}
                            <div className="bg-stone-100 p-4 rounded-lg w-full mb-6 text-left space-y-2">
                                <p className="text-stone-500">
                                    Recipient Name: <span className="font-bold text-stone-800">Harvest Chapel Int'l</span>
                                </p>
                                <p className="text-stone-500">
                                    Phone Number: <span className="font-bold text-stone-800">{zellePhoneDisplay}</span>
                                </p>
                            </div>
                            
                            <button 
                                onClick={() => handleCopy(zellePhone, 'zelle')} 
                                className={`w-full font-bold py-3 px-6 rounded-full text-lg transition-all duration-300 mt-auto ${copiedItem === 'zelle' ? 'bg-green-500 text-white' : 'bg-orange-500 hover:bg-orange-600 text-white'}`}
                            >
                                {copiedItem === 'zelle' ? 'Copied!' : 'Copy Phone Number'}
                            </button>
                        </div>

                        {/* PayPal Card (No changes) */}
                        <div className="bg-white rounded-lg shadow-lg p-6 md:p-8 text-center flex flex-col items-center transform hover:-translate-y-2 transition-transform duration-300">
                            <div className="bg-orange-100 text-orange-600 p-4 rounded-full mb-4">
                                <Icon name="credit-card" className="w-8 h-8" />
                            </div>
                            <h3 className="text-2xl font-bold font-playfair text-stone-800 mb-2">Give with PayPal</h3>
                            <p className="text-stone-600 mb-6 grow">Click below to give securely using your PayPal account or a debit/credit card.</p>
                            <a href="https://paypal.me/harvestatlanta" target="_blank" rel="noopener noreferrer" className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-6 rounded-full text-lg transition-transform duration-300 transform hover:scale-105 cursor-pointer mt-auto">
                                Go to PayPal
                            </a>
                        </div>
                        
                        {/* --- Venmo Card (Further UI improvements) --- */}
                        <div className="bg-white rounded-lg shadow-lg p-6 md:p-8 text-center flex flex-col items-center transform hover:-translate-y-2 transition-transform duration-300">
                            <div className="bg-orange-100 text-orange-600 p-4 rounded-full mb-4">
                                <Icon name="smartphone" className="w-8 h-8" />
                            </div>
                            <h3 className="text-2xl font-bold font-playfair text-stone-800 mb-2">Give with Venmo</h3>
                            <p className="text-stone-600 mb-6 grow">Send your gift through Venmo from your mobile device using our phone number.</p>

                            {/* Streamlined Phone Number Info Box */}
                            <div className="bg-stone-100 p-4 rounded-lg w-full mb-6 text-left space-y-2">
                                <p className="text-stone-500">
                                    Phone Number: <span className="font-bold text-stone-800">{zellePhoneDisplay}</span>
                                </p>
                            </div>

                            <button 
                                onClick={() => handleCopy(zellePhone, 'venmo')} 
                                className={`w-full font-bold py-3 px-6 rounded-full text-lg transition-all duration-300 mt-auto ${copiedItem === 'venmo' ? 'bg-green-500 text-white' : 'bg-orange-500 hover:bg-orange-600 text-white'}`}
                            >
                                {copiedItem === 'venmo' ? 'Copied!' : 'Copy Phone Number'}
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        );
    };

    // --- ADDED: New Component for the Community Gallery Page ---
    const CommunityMomentsPage = () => {
        const galleryImages = [
            { src: 'https://placehold.co/600x400/854d0e/FFFFFF?text=Youth+Camp', title: 'Youth Camp 2025', category: 'Youth Ministry' },
            { src: 'https://placehold.co/600x400/b45309/FFFFFF?text=DOZ+Conference', title: 'Annual DOZ Conference', category: 'Daughters of Zion' },
            { src: 'https://placehold.co/600x400/d97706/FFFFFF?text=MOVE+Breakfast', title: 'Men\'s Prayer Breakfast', category: 'Men of Vision' },
            { src: 'https://placehold.co/600x400/92400e/FFFFFF?text=Couples+Dinner', title: 'Valentine\'s Dinner', category: 'Couples Fellowship' },
            { src: 'https://placehold.co/600x400/a16207/FFFFFF?text=Praise+Night', title: 'Worship & Praise Night', category: 'Choir' },
            { src: 'https://placehold.co/600x400/713f12/FFFFFF?text=Kids+Fun+Day', title: 'Kiddie Haven Fun Day', category: 'Kiddie Haven' },
            { src: 'https://placehold.co/600x400/854d0e/FFFFFF?text=Youth+Outing', title: 'Summer Beach Outing', category: 'Youth Ministry' },
            { src: 'https://placehold.co/600x400/b45309/FFFFFF?text=DOZ+Outreach', title: 'Community Outreach', category: 'Daughters of Zion' },
        ];

        return (
            <section id="community-moments" className="py-20 md:py-28 bg-white">
                <div className="container mx-auto px-6">
                    <SectionTitle>Community Moments</SectionTitle>
                    <SectionSubtitle>
                        Capturing the joy, fellowship, and vibrant life of our church family. See the moments that make us who we are.
                    </SectionSubtitle>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {galleryImages.map((image, index) => (
                            <div key={index} className="group relative rounded-lg overflow-hidden shadow-lg">
                                <img src={image.src} alt={image.title} className="w-full h-64 object-cover transform group-hover:scale-110 transition-transform duration-500" />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/75 to-transparent"></div>
                                <div className="absolute bottom-0 left-0 p-4 text-white">
                                    <p className="text-sm font-semibold text-orange-300">{image.category}</p>
                                    <h3 className="text-xl font-bold font-playfair">{image.title}</h3>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        );
    };


    // --- Main App Component ---

    export default function App() {
        const [currentPage, setCurrentPage] = useState('home');

        useEffect(() => {
            window.scrollTo(0, 0);

            // This function will handle creating icons
            const createIcons = () => {
                // Check if the lucide library is available on the window object
                if (window.lucide) {
                    window.lucide.createIcons();
                }
            };

            const scriptId = 'lucide-script';
            const existingScript = document.getElementById(scriptId);

            // If script is already loaded, just create the icons
            if (existingScript) {
                createIcons();
                return;
            }

            // Otherwise, load the script and then create the icons
            const script = document.createElement('script');
            script.id = scriptId;
            script.src = 'https://unpkg.com/lucide@latest';
            script.async = true;
            // Set the onload event handler to call our function
            script.onload = createIcons;

            document.body.appendChild(script);

        }, [currentPage]); // Re-run this effect every time the page changes

        const renderPage = () => {
            switch (currentPage) {
                case 'new-here':
                    return <NewHerePage />;
                case 'about':
                    return <AboutPage />;
                case 'services':
                    return <ServicesPage />;
                case 'events':
                    return <EventsPage />;
                case 'giving':
                    return <GivingPage />;
                // --- ADDED: Case for the new community page ---
                case 'community-moments':
                    return <CommunityMomentsPage />;
                case 'home':
                default:
                    return <HomePage setCurrentPage={setCurrentPage} />;
            }
        };

        return (
            <div className="bg-gray-50 text-stone-700">
                {/* --- UPDATED: Self-contained style block --- */}
                <style>{`
                    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Playfair+Display:wght@700;800&display=swap');
                    
                    body { 
                        font-family: 'Inter', sans-serif; 
                    }
                    .font-playfair { 
                        font-family: 'Playfair Display', serif; 
                    }
                    .hero-bg {
                        background-image: linear-gradient(rgba(20, 10, 5, 0.6), rgba(20, 10, 5, 0.6)), url('https://images.pexels.com/photos/1118428/pexels-photo-1118428.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2');
                        background-size: cover;
                        background-position: center;
                    }
                    /* Helper for aspect ratio on homepage gallery */
                    .aspect-w-1 { --tw-aspect-w: 1; }
                    .aspect-h-1 { --tw-aspect-h: 1; }
                    .aspect-w-1.aspect-h-1 {
                        position: relative;
                        padding-bottom: calc(var(--tw-aspect-h) / var(--tw-aspect-w) * 100%);
                    }
                    .aspect-w-1.aspect-h-1 > * {
                        position: absolute;
                        height: 100%;
                        width: 100%;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        left: 0;
                    }
                `}</style>
                <Header currentPage={currentPage} setCurrentPage={setCurrentPage} />
                <main className="pt-20"> {/* Padding top for fixed header */}
                    {renderPage()}
                </main>
                <Footer />
            </div>
        );
    }